import React, { useMemo, useState } from "react";
import AttachmentContainer from "../../pages/groupChat/attachmentContainer";
import HighlightMentions from "../highlightMention";
import MarkdownToHtml from "../markdownToHtml";
import { HiExclamation } from "react-icons/hi";
import { RiCheckDoubleFill } from "react-icons/ri";
import { highlightMentionText } from "../../helpers/utility";
import { useGroupChatContext } from "../../context/groupchatContext";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import ActionDialog from "../actionDialog";
import MainPageDialog from "../dialog";
import AutoMessageReplyWindow from "../../pages/chatbot/autoMessageReply";
import Tooltip from "../Tooltip";
import moment from "moment";
import useSendPdfToChat from "../../hooks/useSendPdfToChat";

export const BaseMessage = ({msg, isLoggedInUser}) => {

  const groupChatContext = useGroupChatContext();
  const { authData } = useMemo(() => ({
    authData: groupChatContext.authData,
  }));

  const [confirmation, setConfirmation] = useState({ open: false });
  const [isOpenAutoReplyPopup, setIsOpenAutoReplyPopup] = useState(false);

  const msgText = msg?.message?.text ? msg?.message?.text?.replaceAll('\n', '<br>') : "";
  const highlightedText = highlightMentionText(msgText);

  const {sendPdfToChat, isSending} = useSendPdfToChat();

  const confirmationAutoReply = () => {
    setConfirmation({ open: true})
  }

  const isOpenInEditor = (mime_type) => {
    if(mime_type == 'pdf' || mime_type == 'application/pdf'){
      return true
    }

    return false;
  }

  const renderMessageBorder = () => {
    if (msg?.acknowledged_at && (msg?.acknowledged_by_nurse_id || msg?.acknowledged_by_user_id)) {
      return 'border-green';
    } else if (msg?.message?.urgent || msg?.urgent) {
      return 'border-red'; 
    } else {
      return "";
    }
  }

  return (
    <>
      <div className={`rounded-md ${isLoggedInUser() ? 'bg-blue-100': 'bg-light-gray-f1 border' } ${renderMessageBorder()}  p-2 shadow`}>
        <div className={`text-gray-800 text-start`}>
          {/* {msgText.map((text, index)=>(
            <span key={index}>
              {text}
              <br />
            </span>
          ))} */}
          <div className="flex gap-3 items-center">
            <MarkdownToHtml markdownText={highlightedText} /> 
            {authData?.is_provider ? <InformationCircleIcon title="Auto Reply" onClick={confirmationAutoReply} className="ml-2 h-5 w-5 cursor-pointer flex-shrink-0" /> : null}
            {(msg?.acknowledged_at && (msg?.acknowledged_by_nurse_id || msg?.acknowledged_by_user_id)) ? 
             <Tooltip 
            //  position="right"
             content={
             <div className="flex flex-col items-start gap-2">
                <p><span>Acknowledged by</span>{" "}<span className="font-bold">{(msg?.acknowledged_by_name)}</span>{" "}on{" "}<span className="font-bold">{(moment(msg?.acknowledged_at)?.format("MM/DD/YYYY hh:mm A"))}</span></p>
             </div>}>
              <div className="flex items-center justify-center bg-white rounded-full h-[20px] w-[20px] border border-slate-200">
                <RiCheckDoubleFill className="text-green-700" />
              </div>
             </Tooltip> : 
             (msg?.message?.urgent || msg?.urgent) ? 
             <HiExclamation title="Urgent Message" className="text-red-500 mt-1" /> : 
             null}
          </div>
          {/* <HighlightMentions text={msgText} /> */}
          {msg?.message?.media?.length ?
            <div className="mt-2">
              <AttachmentContainer
                isShowLinkToPatientChartWithImage={true}
                data={{...msg, files: msg?.message?.media}}
                openInEditor={isOpenInEditor(msg?.message?.media[0]?.mime_type)}
                callBackFun={sendPdfToChat}
                includeOrigAttachId
                stackFiles
              />
            </div>
            : null
          }
        </div>
      </div>

      <ActionDialog
        onCancelHandler={() => setConfirmation({ open: false })}
        onConfirmHandler={() => {
          setConfirmation({ open: false });
          setIsOpenAutoReplyPopup(true)
        }}
        showModal={confirmation.open}
        headerTitle="Auto Suggest Reply"
        title="Do you want to generate a reply?"
        cancelButtonText="No"
        confirmButtonText="Yes"
        setShowModal={() => setConfirmation({ open: false })}
      />

      {isOpenAutoReplyPopup ?
        <MainPageDialog
            title="Suggest Reply"
            onCancelHandler={() => setIsOpenAutoReplyPopup(false)}
            maxHeight={true}
            customHeight={"max-h-[80vh]"}
            component={
              <AutoMessageReplyWindow msgId={msg?.id} closeHandler={() => setIsOpenAutoReplyPopup(false)} />
            }
            footer={false}
        >
        </MainPageDialog>
        : null
      }
    </>
  );
};